import { Record } from 'immutable';
import uuid from 'node-uuid';
import { ENCODER_JOB_TEMPLATE_ID } from './constants';

export const Actions = Object.seal({
  CREATE: '@jobs/create',
  UPDATE: '@jobs/update',
  REMOVE: '@jobs/remove',
});

export const EncoderJob = Record({
  id: '',
  jobTemplateId: '',
  status: '',
  created: undefined,
  modified: undefined,
  active: true,
  deleted: false,
  name: '',
  data: [],
  params: [],
});

EncoderJob.create = data => {
  return new EncoderJob({
    id: data.id || uuid.v4(),
    jobTemplateId: ENCODER_JOB_TEMPLATE_ID,
    name: data.name || 'Encoder job for episode',
    params: [
      { key: 'episodeId', value: data.episode },
      { key: 'showId', value: data.show },
      { key: 'mediaUrl', value: data.media },
    ],
    data: [],
  });
};
